<ng-template #spinner>
   <mat-spinner id="spinnerCod" diameter="30"></mat-spinner>
</ng-template>

<ng-container *ngIf="cod as cod">
   <div class="cod" [formGroup]="cod" [class.invalid]="(shipment.highlightInvalid$ | async) && cod.invalid">
      <div class="overline">COD</div>

      <div class="cod-inputs">
         <mat-form-field class="cod-type">
            <mat-label>Type</mat-label>
            <mat-select id="codSelect" formControlName="type" [required]="config?.items?.type?.required || cod?.errors?.allOf?.includes( config?.allOf?.type?.label )">
               <mat-option id="codOption" (click)="resetOption()" value="none">None</mat-option>
               <mat-option id="codOption" (click)="valueOption()" value="check">Check</mat-option>
               <mat-option id="codOption" (click)="otherOption()" value="other">Other</mat-option>
            </mat-select>
            <mat-error id="codTypeError" libInputErrors [control]="cod.get('type')"></mat-error>
         </mat-form-field>

         <ng-container *ngIf="cod.get('type').value == 'check'">
            <mat-form-field #codamount class="cod-amount">
               <mat-label>Amount</mat-label>
               <input id="codAmountInput" matInput type="number" formControlName="amount" [required]="config?.items?.amount?.required || cod?.errors?.allOf?.includes( config?.allOf?.amount?.label )" [min]="config?.items?.amount?.min" />
               <mat-error id="codAmountError" libInputErrors [control]="cod.get('amount')"></mat-error>
            </mat-form-field>

            <lib-currency-selector id="codCurrencySelector" formControlName="currency"></lib-currency-selector>
         </ng-container>
      </div>

      <span id="codOtherHint" class="cod-other" *ngIf="cod.get('type').value == 'other'">COD information located in Special Instructions<br/><br/></span>

      <mat-error id="codError" *ngIf="(shipment.highlightInvalid$ | async) && cod.invalid" libInputErrors [control]="cod"></mat-error>
   </div>
</ng-container>
